import React, {useEffect, useState} from 'react';
import {eliminarFeriado, mostrarFeriados} from '../../redux/reducers/feriadosReducers';
import AppBar from "../../components/appBar";
import Crear from './crear';
import {Button, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText} from "@mui/material";
import PlusFab from "../../components/PlusFab";
import {Close} from "@mui/icons-material";
import LoadingProgress from "../../components/LoadingProgress";
import {useLocation, useNavigate} from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import {MostrarError} from "../../components/MostrarError";
import Strings from "../../assets/strings";
import {formatDate, hasPermissionTo, noTilde, PERSMISOS} from "../../helpers";
import {Empty, ListViewMode, SeacrhAppBar} from "../../components";
import {ReactComponent as EmptySvg} from "../../assets/img/hollyday.svg";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

export default function Feriados() {
    const navigate = useNavigate();
    const Dispatch = useAppDispatch();
    const { list, status, error } = useAppSelector(state => state.feriados);
    const {state:urlState,pathname} = useLocation();
    const [searchBox, setSearchBox] = useState("");


    useEffect(() => {
        Dispatch(mostrarFeriados());
    }, [Dispatch]);


    const isEmpty = status === "loading" && list.length === 0;


    const filterItems = () => {
        return list.filter(item=> noTilde(item.descripcion).indexOf(noTilde(searchBox)) !== -1);
    }
      return <>
          <AppBar />

          <section className="contentInner" style={!isEmpty ? {maxWidth:600, margin:"0 auto"}:{}}>
              {!urlState && <MostrarError errors={error}/>}
              {status === "loading"  && !list.length && <LoadingProgress vh/>}
              <ListViewMode pageRows={list?.length} pageTotalRows={list?.length} noView>
                  <SeacrhAppBar name="search" value={searchBox} onChange={({target}:any)=>setSearchBox(target.value)}/>
              </ListViewMode>
              <List >
                  {!isEmpty && filterItems().map(item =>
                      <ListItem key={item.id}>
                          <ListItemText primary={item.descripcion} secondary={formatDate(item.fecha)}/>
                          {hasPermissionTo(PERSMISOS.feriadoEliminar) && !item.registroDelSistema &&
                          <ListItemSecondaryAction>
                              <IconButton
                                  edge="end"
                                  aria-label="comments"
                                  onClick={()=>navigate(pathname,{state:{confirmDialog:item.id}})}
                                  size="large">
                                  <Close className="text-red" fontSize={"small"}/>
                              </IconButton>
                          </ListItemSecondaryAction>
                          }
                      </ListItem>
                  )}
              </List>
              {list.length === 0 &&
              <Empty Img={EmptySvg} title={Strings.aunNoTienes+" "+Strings.feriados}>
                  <p>{Strings.feriadosHelpMsj}</p>
              </Empty>
               }


              {hasPermissionTo(PERSMISOS.feriadoCrear) &&
                  <PlusFab component={Button} onClick={()=>navigate(pathname,{state: {feriado:true}})} />
              }
              <Crear/>


              <ConfirmDialog onConfirm={()=>Dispatch(eliminarFeriado(urlState?.confirmDialog))}/>

          </section>
      </>;

}

